// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"72":"Cart","80":"Orders","301":"OneFoodPage","672":"Admin","751":"Food","888":"Auth"}[chunkId] || chunkId) + "." + {"72":"d088b794","80":"cf1c8d11","301":"cfcb534e","672":"04591e1b","751":"a93c0e42","886":"655abc48","888":"e60e62c9"}[chunkId] + ".chunk.js";
};